import React from 'react'

import SidePanelTransition from './sidePanel-transition'
import {openPanel} from './sidePanel-action'

class SidePanelContainer extends React.Component {
    static SIDE_PANEL_ID = 0;

    sidePanelId = "sidePanel-container-component-" + (SidePanelContainer.SIDE_PANEL_ID++)

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.langReducers && nextProps.langReducers.locale !== this.props.langReducers.locale) return

        let {sidePanelData, className} = nextProps
        if(sidePanelData) {
            let {type, id} = sidePanelData
            openPanel(this.sidePanelId, {type, attrs:{ id }}, className)
            return;
        }
    }

    open(type, id) {
        this.props.dispatch({sidePanelId: this.sidePanelId, type, id})
    }

    panel() {
        throw new Error('panel() should be override', this)
    }

    render() {
        return <div className="sidePanel-container">
            {this.panel()}
            <SidePanelTransition id={this.sidePanelId} />
        </div>
    }
}

export default SidePanelContainer
